export default __webpack_public_path__ + "static/media/wistor-logo-white-with-text.8e0d5b43.svg";